// @ts-check
import { api } from "../client.js";

/**
 * Usuários da clínica.
 *
 * O painel Master usa os mesmos verbos sob `/master/users` — ver
 * `masterApi.users` em `master.js`.
 */
export const usersApi = {
  /** @param {{ search?: string, role?: string }} [filtros] */
  list: (filtros) => api.get("/users", filtros),

  /** @param {{ fullName: string, email: string, role: string, password?: string }} dados */
  create: (dados) => api.post("/users", dados),

  /** @param {string} id @param {object} patch */
  update: (id, patch) => api.patch(`/users/${id}`, patch),

  /** @param {string} id @param {{ password?: string }} [dados] */
  resetPassword: (id, dados = {}) => api.post(`/users/${id}/reset-password`, dados),

  /** @param {string} id */
  remove: (id) => api.delete(`/users/${id}`),
};
